module.exports = __webpack_public_path__ + "static/michele-hodges-94f2b3feb63aded8ceb38b009af40652.jpg";